import req from "@/assets/js/req";
let _idCount = 0;
let logs = [];
let logAction = [];
function sendToServer () {
    if (logs.length === 0) return false;
    req({
        url: "/analy/page/save",
        method: "POST",
        data: { pageRecords: JSON.stringify(logs) }
    });
    logs = [];
    logAction = [];
}
window.onbeforeunload = function (e) {
    e = e || window.event;
    // 兼容IE8和Firefox 4之前的版本
    if (e) {
        sendToServer();
        return;
    }
    // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
    sendToServer();
};
export default {
    getId () {
        return _idCount++;
    },
    set (type, ...args) {
        let logObj = {
            id: this.getId(),
            time: new Date().getTime(),
            type: type,
            msg: ""
        };
        for (let item of args) {
            let msgStr = "";
            if (typeof item === "object") {
                msgStr += JSON.stringify(item) + ", ";
            } else {
                msgStr += item + ", ";
            }
            logObj.msg += msgStr;
        }
        logAction.push(logObj);
        if (type === "action") {
            args[0].time = logObj.time;
            logs.push(args[0]);
            if (logs.length > 9) {
                sendToServer();
            }
        }
    },
    clear () {
        _idCount = 0;
        logAction = [];
    },
    get () {
        return logAction;
    },
    trace (...args) {
        this.set("trace", ...args);
    },
    debug (...args) {
        this.set("debug", ...args);
    },
    info (...args) {
        this.set("info", ...args);
    },
    action (...args) {
        this.set("action", ...args);
    },
    error (...args) {
        this.set("error", ...args);
    },
    fatal (...args) {
        this.set("fatal", ...args);
    }
};
